import { trigger, state, style, transition, animate } from '@angular/animations';
import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Inject, OnDestroy, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { AppService } from 'src/app/_services/app.service';

@Component({
    selector: 'app-contribution-summary',
    templateUrl: './contribution-summary.component.html',
    styleUrls: ['./contribution-summary.component.css'],
    animations: [
        trigger('slider', [
            state('hide', style({
                height: 0
            })),
            state('show', style({
                height: '*'
            })),
            transition('* <=> show', [animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')])
        ])
    ],
    standalone: false
})
export class ContributionSummaryComponent implements OnInit, OnDestroy {

  displayColumns: string [] = ['contributor', 'contributed', 'assessor', 'assessed', 'status'];
  contributionsLength: number = 0;
  summaryRecords: ContributeSummaryRecord[];
  marketId: string;
  hasInterval: boolean = false;
  dataSource;
  intervals: any[] = [];

  allowSubmission: boolean = false;
  allowTransaction: boolean = false;
  isMarketOpen: boolean = false;
  lastTransaction: Date = null;
  lastTransactionStatus: Date = null;

  @Output() getContributions: EventEmitter<any> = new EventEmitter();
  @Output() getTransactions: EventEmitter<any> = new EventEmitter();
  @Output() checkOverrideWindow: EventEmitter<any> = new EventEmitter();

  constructor(private route: ActivatedRoute, private service: AppService,  private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {
    // this.service.SetTranslation('my-general-markets/contribution-summary');
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.marketId = params['ID'];
      this.GetSummary();
    });
  }

  ngOnDestroy() {
    if (this.intervals.length > 0) {
      this.intervals.forEach(interval => {
        clearInterval(interval);
      });
    }
  }

  /** Gets the summary details */
  GetSummary() {
    this.http.get<ContributeSummary>(this.baseUrl + 'api/contribute/getSummary/' + this.marketId).subscribe(result => {
      let updated: boolean = false;
      let initial: boolean = false;
      if (!this.summaryRecords || JSON.stringify(this.summaryRecords) !== JSON.stringify(result.records)) {
        updated = true;
        if (!this.summaryRecords) {
          initial = true;
        }
      }

      if (updated === true) {
        this.summaryRecords = result.records;
        this.contributionsLength = this.summaryRecords.length;
        this.dataSource = new MatTableDataSource(this.summaryRecords);
        if (initial === false) {
          this.getContributions.emit();
        }
      }

      if (this.hasInterval === false) {
        this.hasInterval = true;
        const interval = setInterval(() => {
          this.GetSummary();
        }, 1000);
        this.intervals.push(interval);
      }

      if (initial === false) {
        let triggerParent: Boolean = false;
        if (this.allowSubmission !== result.allowSubmission || this.allowTransaction !== result.allowTransaction) {
          this.allowTransaction = result.allowTransaction;
          this.allowSubmission = result.allowSubmission;
          triggerParent = true;
        }

        if (this.isMarketOpen !== result.isMarketOpen) {
          this.isMarketOpen = result.isMarketOpen;
          triggerParent = true;
        }

        if (this.lastTransaction !== result.lastTransaction) {
          this.lastTransaction = result.lastTransaction;
          triggerParent = true;
        }

        if (this.lastTransactionStatus !== result.lastTransactionStatus) {
          this.lastTransactionStatus = result.lastTransactionStatus;
          this.getTransactions.emit();
        }

        if (triggerParent === true) {
          this.getContributions.emit();
          this.checkOverrideWindow.emit();
        }
      } else {
        this.isMarketOpen = result.isMarketOpen;
      }
    }, error => {
      console.error(error);
    });
  }

}

/** An interface to access a summary record */
interface ContributeSummaryRecord {
  contributor: string;
  contributed: Date;
  assessor: string;
  assessed: Date;
  status: string;
}


interface ContributeSummary {
  allowTransaction: boolean;
  allowSubmission: boolean;
  isMarketOpen: boolean;
  lastTransaction: Date;
  lastTransactionStatus: Date;
  records: ContributeSummaryRecord[];
}
